import React from "react";
import { Box, Card, LinearProgress, Typography } from "@mui/material";
import dayjs from "dayjs";
import { useSelector } from "react-redux";

const Ifu = () => {
  const { searchIFU } = useSelector((state: any) => state.chat);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        marginTop: "2rem",
      }}
    >
      <Box
        sx={{
          alignItems: "flex-end",
          display: "flex",
          flexDirection: "column",
          width: "auto",
          maxWidth: "70%",
        }}
      >
        <Box className="flex">
          <Box
            sx={{
              borderRadius: "50%",
              bgcolor: "#fff",
              width: "35px",
              height: "35px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mr: 1,
            }}
          >
            <Typography sx={{ fontSize: "0.8rem" }}>OX</Typography>
          </Box>
          <Box
            sx={{
              bgcolor: "white",
              p: 2,
              borderRadius: 1,
              border: "1px solid #ddd",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
              <Typography
                variant="body1"
                sx={{ fontWeight: "normal", whiteSpace: "pre-line" }}
              >
                IFU File
              </Typography>
            </Box>

            {(() => {
              if (searchIFU.loading) {
                return <LinearProgress />;
              }
              if (searchIFU.error) {
                return (
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: "normal", whiteSpace: "pre-line" }}
                  >
                    {searchIFU.error}
                  </Typography>
                );
              }
              return (
                <Card
                  onClick={() => window.open(searchIFU.url, "_blank")}
                  sx={{
                    position: "relative",
                    cursor: "pointer",
                    display: "inline-block",
                  }}
                >
                  <img
                    src={"/assets/images/FilesIcon.png"}
                    alt="IFU File"
                    width={100}
                    height={100}
                    style={{
                      borderRadius: "8px",

                      cursor: "pointer",
                    }}
                  />
                </Card>
              );
            })()}
          </Box>
        </Box>
        <Box>
          <Typography variant="caption" color="textSecondary">
            {dayjs().format("DD-MMM HH:mm")}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Ifu;
